//https://scotch.io/tutorials/handling-authentication-in-vue-using-vuex
import axios from 'axios';

//Des variables
const state = () => ({
  currentToken: localStorage.getItem('token') || '',
  currentUser: JSON.parse(localStorage.getItem('user')) || {},
  currentAgence: JSON.parse(localStorage.getItem('agence')) || {},
  currentCoeff: localStorage.getItem('user.coefficientFavori') || '',
  currentPerm: JSON.parse(localStorage.getItem('perm')) || {},
  currentPeriod: {},
})

//Comment ces variables changent
const mutations = {
  auth_success(state, payload){
    state.currentToken = payload.token;
    state.currentUser = payload.user;
    state.currentPerm = payload.perm;
  },
  set_agence(state, payload){
    state.currentAgence = payload.agence;
  },
  set_coeffFavori(state, coeffLabelId){
    state.currentUser.coefficientFavori = coeffLabelId
    let user = JSON.parse(localStorage.getItem('user'))
    user.coefficientFavori = coeffLabelId
    localStorage.setItem('user', JSON.stringify(user));
  },
  logout(state){
    state.currentToken      = '';
    state.currentUser       = '';
    state.currentAgence     = '';
    state.currentCoeff      = '';
    state.currentPerm       = '';
  },
  majMode(state, newMode){
    state.currentAgence.modeSaisie = newMode;
  },
}

//Combo de plusieurs mutations
const actions = {
    login({commit}, payload){
        commit('auth_success', payload);
        localStorage.setItem('token', payload.token);    
        localStorage.setItem('user', JSON.stringify(payload.user));
        localStorage.setItem('perm', JSON.stringify(payload.perm));
        axios.defaults.headers.common['authorization'] = payload.token;
    },
    set_agence({commit}, payload){
      commit('set_agence', payload)
      //Avant de stringify, je vérifie qu'il y ai bien une valeur. Sinon, si ma valeur est undefined par exemple, le stringify va crée une chaine de caractère = "undefined". Et donc il y aura une valeur pour cet item dans le local storage, et donc le state va essayer de s'initialiser avec cette chaine de caractère qui ne va pas être recoonu par JSON. C'est à dire que l'expression : JSON.parse(localStorage.getItem('agence')) || {} va essayer de parser la chaine "undefined" et ne vas pas y arriver : ce n'est pas du JSON...
      if (payload.agence){localStorage.setItem('agence', JSON.stringify(payload.agence))}
    },
    set_coeffFavori({commit}, payload){
      commit('set_coeffFavori', payload)
    },
    logout({commit}){
      commit('logout');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('agence');
      localStorage.removeItem('perm');
      delete axios.defaults.headers.common['authorization'];
    },
    majMode({commit}, agence){
      commit('majMode', agence.modeSaisie)
      localStorage.setItem('agence', JSON.stringify(agence));
    },
    // majUser({commit}, user){
    //   commit('majUser', user)
    //   localStorage.setItem('user', JSON.stringify(user));
    // },
}

//Etat d'un state retravaillé (mise en forme, concaténation, etc.)
const getters = {
  displayAll: state => {
      return `Token : ${state.currentToken} | Statut : ${state.authStatut} | username : ${state.currentUser.name}`
  },
  isLoggedIn: state => !!state.currentToken,
  username: state => {
    let displayedUsername = state.currentUser.name + " " + state.currentUser.surname
     if (displayedUsername.length > 16){
      displayedUsername = displayedUsername.substring(0, 15) + "...";
     }
    return displayedUsername
  },
  agence: state => {
    return state.currentAgence.name
  },
  modeSaisie: state => {
    let modeSaisie = '';
      switch (state.currentAgence.modeSaisie){
        case 1:
          modeSaisie = 'heures';
          break;
        // case 2: (semaine)
        case 3:
          modeSaisie = 'jours';
          break;
        default:
          console.log("Mode de saisie inconnu. Passage à 'heures pas jour' par défaut.");
          modeSaisie = 'heures';
      }
    return modeSaisie
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}